"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = exports.ModalSize = void 0;
const i18n_1 = require("../../utils/i18n");
const react_1 = __importDefault(require("react"));
const modalStyles = {
    display: 'block',
    background: 'white',
    position: 'relative',
    margin: '1.75rem auto',
    top: '7em',
    borderRadius: '5px',
    zIndex: '1044',
    width: '100%',
    boxShadow: '0 10px 20px 0 rgba(0, 0, 0, 0.18)',
    overflow: 'visible'
};
var ModalSize;
(function (ModalSize) {
    ModalSize["SMALL"] = "small";
    ModalSize["MEDIUM"] = "medium";
    ModalSize["LARGE"] = "large";
})(ModalSize || (exports.ModalSize = ModalSize = {}));
const stylingMap = {
    [ModalSize.SMALL]: { maxWidth: '480px' },
    [ModalSize.MEDIUM]: { maxWidth: '500px' },
    [ModalSize.LARGE]: { minWidth: '720px', maxWidth: '720px' },
};
const Modal = ({ title, size, close, children, ariaMessage }) => {
    return (react_1.default.createElement("div", { className: "modal", role: "dialog", "aria-label": ariaMessage, style: Object.assign(Object.assign({}, modalStyles), stylingMap[size]), onClick: (e) => e.stopPropagation() },
        react_1.default.createElement("div", { className: "modal-content" },
            react_1.default.createElement("div", { className: "modal-header", style: { paddingTop: "0px" } },
                react_1.default.createElement("div", { className: "modal-title" },
                    react_1.default.createElement("button", { className: "icon--cross close", autoFocus: true, onClick: close, "aria-label": (0, i18n_1.text)('popup.close') }),
                    react_1.default.createElement("h3", null, title))),
            react_1.default.createElement("div", { className: "modal-body" }, children))));
};
exports.Modal = Modal;
